__turbopack_context__.v({
  "className": "merriweather_f94872d9-module__fM4USq__className",
  "variable": "merriweather_f94872d9-module__fM4USq__variable",
});
